import get from 'lodash/get';
import React from 'react';

import AppContext from '../services/Context';
import styled from '../styled-components';
import Icon from './Icon';

type PropType = {
  children?: React.ReactNode;
  type?: string;
  loading?: boolean;
  disabled?: boolean;
  icon?: any;
  className?: string;
  onClick?: any;
};
// TODO: types

const ButtonComponent = ({
  children,
  type,
  loading,
  disabled,
  icon,
  className = 'default',
  onClick,
}: PropType) => (
  <AppContext.Consumer>
    {({ theme }) => (
      <Button
        theme={theme}
        disabled={disabled}
        className={`${className}`}
        type={type}
        onClick={onClick}
      >
        {icon && (
          <IconWrapper spaceRight={5}>
            <Icon {...icon} />
          </IconWrapper>
        )}
        {children || ' '}
        {loading && (
          <IconWrapper spaceLeft={5}>
            <Icon spin name="spinner" />
          </IconWrapper>
        )}
      </Button>
    )}
  </AppContext.Consumer>
);

const getButtonThemeIndex = (className: string) => {
  if (className.indexOf('link') > -1) {
    switch (true) {
      case className.indexOf('primary') > -1:
        return 'link.primary';
      case className.indexOf('danger') > -1:
        return 'link.danger';
      default:
        return 'link.default';
    }
  }
  if (className.indexOf('outline') > -1) {
    switch (true) {
      case className.indexOf('primary') > -1:
        return 'outline.primary';
      case className.indexOf('danger') > -1:
        return 'outline.danger';
      default:
        return 'outline.default';
    }
  }
  switch (true) {
    case className.indexOf('primary') > -1:
      return 'button.primary';
    case className.indexOf('danger') > -1:
      return 'button.danger';
    default:
      return 'button.default';
  }
};

const Button = styled.button`
  ${({ theme, className = '' }) => get(theme, `${getButtonThemeIndex(className)}`)};

  &.bolder {
    font-weight: bolder;
  }
  &:disabled {
    ${({ theme, className = '' }) =>
      get(theme, `button.${getButtonThemeIndex(className)}.disabled`)};
    cursor: default;
    opacity: 0.5;
  }
  &:hover:enabled {
    ${({ theme, className = '' }) => get(theme, `${getButtonThemeIndex(className)}.hover`)};
    cursor: pointer;
  }
`;

const IconWrapper: any = styled.span`
  padding-left: ${({ spaceLeft }: any) => (spaceLeft ? `${spaceLeft}px` : '0px')};
  padding-right: ${({ spaceRight }: any) => (spaceRight ? `${spaceRight}px` : '0px')};
`;

export default ButtonComponent;
